import LeadForm from "@/components/site/LeadForm";

export default function RequestSection() {
  return (
    <section id="request" className="py-24 px-6" data-testid="request-section">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="font-mono text-xs uppercase tracking-widest text-clay font-bold">
          Direct Access
        </span>
        <h2 className="font-display text-3xl md:text-4xl text-ink mt-2 mb-4">
          Request technical demonstration
        </h2>
        <p className="font-body text-umber text-sm">
          Experience the sovereign AI gateway configured for your specific
          enterprise constraints.
        </p>
      </div>

      <div className="max-w-xl mx-auto">
        <LeadForm idPrefix="lead" />
      </div>
    </section>
  );
}
